import React from 'react'
import { useFormContext } from 'react-hook-form'

import { useSTheme } from '../../../../styles/theme'
import SBox from 'components/opinionless/SBox'
import FRadioLabel from './FRadioLabel'
import FRadio from './FRadio'
import SText from '../../../opinionless/SText'
import { radio } from '../../styles'
import { errors } from '../../constants'

type FInputRadioProps = {
    name: string
    text: string
    value: string
}

const FInputRadio = (props: FInputRadioProps) => {
    const theme = useSTheme()
    const { register, getValues, watch } = useFormContext()

    watch(props.name)

    return (
        <React.Fragment>
            <FRadioLabel
                marginBottom={'9px'}
                style={{
                    cursor: 'pointer',
                }}
            >
                <SBox maxWidth={'35px'} marginRight={'11px'}>
                    <FRadio
                        name={props.name}
                        id={props.value}
                        type="radio"
                        value={props.value}
                        size={'27px'}
                        ref={register({
                            required: errors.default_at_least_one_choice as string,
                        })}
                        color={
                            getValues(props.name) === props.value ? theme.colors.secondaryColor : radio.color.unselected
                        }
                        marginLeft={'-2px'}
                        marginRight={'5px'}
                    />
                </SBox>
                <SText
                    sx={{ width: '100%' }}
                    dangerouslySetInnerHTML={{
                        __html: props.text,
                    }}
                ></SText>
            </FRadioLabel>
        </React.Fragment>
    )
}

export default FInputRadio
